import React, { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "@/lib/auth";
import { CurrencyProvider } from "@/lib/currencyCtx";
import { api } from "@/lib/api";

import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import AdminOverview from "@/pages/AdminOverview";
import AdminPartners from "@/pages/AdminPartners";
import AdminConfig from "@/pages/AdminConfig";
import AdminDistributions from "@/pages/AdminDistributions";
import AdminDistributionDetail from "@/pages/AdminDistributionDetail";
import PartnerDashboard from "@/pages/PartnerDashboard";
import AppShell from "@/components/AppShell";
import Protected from "@/components/Protected";

function RootRouter() {
  const location = useLocation();
  // Detect OAuth return synchronously
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<LoginGate />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/" element={<HomeRedirect />} />
      <Route
        path="/admin"
        element={
          <Protected role="admin"><AppShell><AdminOverview /></AppShell></Protected>
        }
      />
      <Route
        path="/admin/partners"
        element={
          <Protected role="admin"><AppShell><AdminPartners /></AppShell></Protected>
        }
      />
      <Route
        path="/admin/config"
        element={
          <Protected role="admin"><AppShell><AdminConfig /></AppShell></Protected>
        }
      />
      <Route
        path="/admin/distributions"
        element={
          <Protected role="admin"><AppShell><AdminDistributions /></AppShell></Protected>
        }
      />
      <Route
        path="/admin/distributions/:id"
        element={
          <Protected role="admin"><AppShell><AdminDistributionDetail /></AppShell></Protected>
        }
      />
      <Route
        path="/dashboard"
        element={
          <Protected><AppShell><PartnerDashboard /></AppShell></Protected>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function HomeRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-atf-bg eyebrow">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
}

function LoginGate() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-atf-bg eyebrow">Loading…</div>;
  if (user) return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
  return <Login />;
}

function ConfiguredProviders({ children }) {
  const [rate, setRate] = useState(83);
  useEffect(() => {
    api.get("/config").then((r) => { if (r.data?.inr_per_usd) setRate(r.data.inr_per_usd); }).catch(() => {});
  }, []);
  return <CurrencyProvider rate={rate}>{children}</CurrencyProvider>;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ConfiguredProviders>
            <Toaster position="top-right" theme="light" toastOptions={{ style: { fontFamily: "IBM Plex Sans", borderRadius: 0, border: "1px solid #E5E4E2" } }} />
            <RootRouter />
          </ConfiguredProviders>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
